import script from "./PersonLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonLink.vue?vue&type=script&setup=true&lang=ts"

import "./PersonLink.vue?vue&type=style&index=0&id=6c0f4bd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0f4bd0"]])

export default __exports__